
export function isGroupAdmin(group, user) {
  if (user.permissions.client_admin) {
    return true
  }
  return group.members.filter(m => {
    return m.email === user.email
  }).length > 0
}